import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, DefaultText, MediumText } from '@guryou/html-components';
import { stateIsLoading, useGender, useServiceCategories } from '@guryou/redux';
import GenderRadio from 'onboard/components/GenderRadio';
import CheckboxInfoContainer from 'onboard/containers/CheckboxInfoContainer';
import FormContainer from 'onboard/containers/FormContainer';
import InfoContainer from 'onboard/containers/InfoContainer';
import MainContainer from 'onboard/containers/MainContainer';
import PlayGuideVideoEmbed from 'onboard/containers/PlayGuideVideoEmbed';
import TitleContainer from 'onboard/containers/TitleContainer';
import { useOnboardContext } from 'onboard/context';
import { guideVideos } from 'onboard/GuideVideosUrls';
import { dealTokens, SystemFormGrid, SystemSelect, SystemTextArea, SystemTextInput } from 'components/shared';

import StepButtons from '../StepButtons';

const ServiceGeneralInformation = () => {
  const { t } = useTranslation();
  const { serviceState, setServiceState } = useOnboardContext();
  const genderOptions = useGender(true);

  const categories = useServiceCategories({ type: 'service' });

  const handleSubmit = data => {
    setServiceState(data);
  };

  return (
    <MainContainer>
      <FormContainer handleSubmit={handleSubmit}>
        <TitleContainer title={t('ONBOARD.serviceTitle')} />
        <Block lg={10} md={12} xs={12} margin={0} marginTop={6}>
          <SystemFormGrid singleColumn>
            <SystemTextInput label={t('ONBOARD.serviceName')} name="serviceName" value={serviceState.serviceName} required />
            <SystemTextArea rows={6} required name="description" label={t('ONBOARD.description')} value={serviceState.description} />
            <SystemSelect
              name="svcTypeId"
              disabled={stateIsLoading(categories)}
              required
              label={t('ONBOARD.category')}
              value={serviceState.svcTypeId}
              none={false}
              options={categories?.data}
            />
          </SystemFormGrid>
          <GenderRadio options={genderOptions} value={serviceState.target} />
        </Block>
        <StepButtons />
      </FormContainer>
      <InfoContainer>
        <MediumText lineHeight="1.3">{t('ONBOARD_TEXT.serviceGeneralInformationTitle')}</MediumText>
        <DefaultText color={dealTokens.color.textMuted} marginTop={2}>
          {t('ONBOARD_TEXT.serviceGeneralInformationSubtitle')}
        </DefaultText>

        <div style={{ marginTop: dealTokens.space[6], paddingTop: dealTokens.space[5], borderTop: `1px solid ${dealTokens.color.border}` }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: dealTokens.font.weightSemibold,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              color: dealTokens.color.textMuted,
              marginBottom: dealTokens.space[4],
            }}
          >
            {t('ONBOARD_TEXT.serviceGeneralInformationCheckboxTitle')}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: dealTokens.space[4] }}>
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceGeneralInformationCheckbox1Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceGeneralInformationCheckbox2Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.serviceGeneralInformationCheckbox3Text')} />
          </div>
        </div>

        <PlayGuideVideoEmbed videoId={guideVideos.serviceGeneralInfo.videoId} modalTitle={guideVideos.serviceGeneralInfo.title} />
      </InfoContainer>
    </MainContainer>
  );
};

export default ServiceGeneralInformation;
